import { PAYMENT_CONFIG } from 'state/paymentConfig/type';
import { ProcessorTableData } from 'types/settings/internalConfig';

export const preprocessTableData = (
  allProcessors: Array<PAYMENT_CONFIG.IProcessors | null>,
  deletedProcessors: Set<string>
): ProcessorTableData[] => {
  return allProcessors
    .filter((processor): processor is PAYMENT_CONFIG.IProcessors => processor !== null)
    .map((processor) => {
      const isDeleted = deletedProcessors.has(processor.processorId);

      let status;
      if (isDeleted) {
        status = 'DELETED';
      } else if (processor.isEnabled === null) {
        status = 'NEEDS_ACTIVATION';
      } else if (processor.isEnabled) {
        status = 'ENABLED';
      } else {
        status = 'DISABLED';
      }

      return {
        ...processor,
        processorName: processor.processorName || '',
        _paymentMethod: processor.paymentMethod || 'ATM',
        _status: status,
      };
    });
};
